// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__GT+UN","modal__title":"modal_modal__title__Nogbs","modal__message":"modal_modal__message__434UL","modal__buttons":"modal_modal__buttons__T2ben"};